export const MAIN_PANEL = 'main';
export const LAYOUT_PANEL = 'layout';
